import React from 'react';
import { useState } from 'react';
import {Collapse} from 'antd'
import {useSelector} from "react-redux";
import '../index.css'

const {Panel} = Collapse
const DictionaryAnswer = (props) =>  {

    const {answer} = props
    const data = answer[0]?.content;
    const {size} = useSelector(state => state.fontSizeChange)
    const theme = localStorage.getItem('ai-chat-theme')
    const answerThree = {
        fontSize: size === '小' ? '12px' : (size === '中' ? '14px' : '16px')
    }
    return (
        <div>
        {
            answer[0]?.content_type==='dictionary'?
                <div className="p-4">
                    <h2 style={{margin:'0 0 20px',padding:0}}>{data.word}</h2>
                    {/* SVG 发音图标 */}
                    <div className="mb-4" dangerouslySetInnerHTML={{ __html: data.svg }} />
                    {/* 词形变化 */}
                    <div className="mb-4">
                        <div>
                            {Object.entries(data.inflections).map(([key, value]) => (
                                <div className="answerThree" style={answerThree}>

                                    <span>{key.replace('_', '-')}: </span>
                                    <font>{value.join(', ')}</font>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        {data.definitions.map((def, index) => (
                            <ExpandableDefinition key={index} def={def} />
                        ))}
                    </div>
                </div>:
            <div className="answerInfo">
                {
                    data.map(res=>{
                        return (<span>{res.text}</span>)
                    })
                }
            </div>
        }
        </div>
    );
}


const ExpandableDefinition=(defs)=> {
    const [isExpanded, setIsExpanded] = useState(false);
    const {def} = defs
    const formatZh = (v)=>{
        return (v.toString().replaceAll(',',';'))
    }
    return(
        <Collapse expandIconPosition={'end'} className={'def-p'}>
            <Panel header={<font className={'def-f'}><span className={'def-l'}>{def.pos}</span>{formatZh(def.zh)}</font>} key="1">
                <div>
                    {def.en.map((enDef, enIndex) => (
                        <div key={enIndex} className="mb-4">
                            <p className="def-va">
                                <span className="def-number">Def-{enIndex + 1}: </span>
                                {/*<ul className="list-ul">*/}
                                {/*    <li>{enDef.shared_definition}</li>*/}
                                {/*</ul>*/}
                                <font className={"list-ul"}>{enDef.shared_definition}</font>
                            </p>
                            {enDef.example_list.length > 0 && (
                                <ul className="">
                                    {enDef.example_list.map((example, exIndex) => (
                                        <li key={exIndex} className="list-ul list-ul-x"><span className={'def-lz'}>例</span> {example}</li>
                                    ))}
                                </ul>
                            )}
                            {enDef.notes_list.length > 0 && (
                                <div className="pl-5">
                                    {enDef.notes_list.map((noteItem, noteIndex) => (
                                        <div key={noteIndex} className="mb-2">
                                            <p className="font-semibold">
                                                <span className="font-semibold not-italic">[note] </span>
                                                {noteItem.note}
                                            </p>
                                            {noteItem.example_list.length > 0 && (
                                                <ul className="">
                                                    {noteItem.example_list.map((noteExample, noteExIndex) => (
                                                        <li key={noteExIndex} className="list-ul list-ul-x"><span className={'def-lz'}>例</span>{noteExample}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </Panel>
        </Collapse>
    )
}



export default DictionaryAnswer
